import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import { PointPlan, UsersOwnedPoint } from 'src/lib/entity/gift-point'
import { LiveUserAuthority } from 'src/lib/entity/live-user-authority'
import { StripeReq } from 'src/lib/entity/gift-point'
import { ConsoleLogger } from 'src/lib/console-logger'
import { Subscription } from 'rxjs'
import { environment } from 'src/env/environment'

@Component({
  selector: 'maglive-gift-charge',
  templateUrl: './gift-charge.component.html',
  styleUrls: ['./gift-charge.component.scss'],
})
export class GiftChargeComponent implements OnInit, OnDestroy {
  @Input() isOpenChargeModal: boolean
  @Input() isScreenRotated: boolean
  @Input() authority: LiveUserAuthority | undefined
  @Input() lackPoint: number | undefined
  @Input() selectedGiftPoint: number | undefined
  @Output() giftChargeModalEvent = new EventEmitter<void>()

  /* Subscription */
  private getPointPlansSub: Subscription | undefined
  private postCheckoutSettionSub: Subscription | undefined

  pointPlans: PointPlan[] | 'NOT_FOUND'
  selectedPointPlan: PointPlan
  redirectUrl: string = window.location.href
  usersOwnedPoint: UsersOwnedPoint
  mag2PointTermsUrl = environment.baseURL.mag2www + 'terms/mag2point.html'

  constructor(private logger: ConsoleLogger) {}

  ngOnInit(): void {
    this.redirectUrl = this.excludeRouteParams()
    this.usersOwnedPoint = this.authority.ownedPoint
    // ポイントプランの取得
    this.getPointPlansSub = MagliveApiClient.getPointPlans().subscribe(
      (value) => {
        this.pointPlans = value
        if (this.pointPlans !== 'NOT_FOUND' && this.pointPlans.length !== 0) {
          this.pointPlans = this.pointPlans.filter((x) => {
            return x.amount >= 50
          })
        }
        this.logger.info(
          this.constructor.name,
          'ngOnInit',
          'pointPlans',
          this.pointPlans
        )
      }
    )
  }

  ngOnDestroy(): void {
    if (this.getPointPlansSub) {
      this.getPointPlansSub.unsubscribe()
    }
    if (this.postCheckoutSettionSub) {
      this.postCheckoutSettionSub.unsubscribe()
    }
  }

  /**
   * ポイントプランの選択処理
   */
  selectPointPlan(pointPlan: PointPlan): void {
    this.selectedPointPlan = pointPlan
  }

  closeChargeModal() {
    this.giftChargeModalEvent.emit()
  }

  /**
   * stripe決済開始。checkout-sessionを生成する
   */
  startPointChargeProcess() {
    const request: StripeReq = {
      successUrl: this.redirectUrl + '?success=true',
      cancelUrl: this.redirectUrl + '?cancel=true',
      pointPlanId: this.selectedPointPlan.pointPlanId,
    }
    this.postCheckoutSettionSub = MagliveApiClient.postCheckoutSession(
      request
    ).subscribe((value) => {
      if (value !== 'NOT_FOUND') {
        window.location.href = value.url
        this.logger.info(
          this.constructor.name,
          'postCheckoutSession',
          'response',
          value
        )
      } else {
        console.error('Stripe api response is not found')
      }
    })
  }

  /**
   * URLからルートパラメータを除去する
   * 同一ウィンドウで複数回チャージが行わる場合を考慮
   */
  private excludeRouteParams(): string {
    const pattern = /[\?]/
    const result = this.redirectUrl.split(pattern)
    this.logger.info(
      this.constructor.name,
      'excludeRouteParams',
      'currentUrl',
      result[0]
    )
    return result[0]
  }
}
